/**
 * Application-wide field help text.
 *
 * These entries cover fields whose meaning is the same in every module
 * (a master-data name, an active toggle, an attachment, and so on).
 * A module dictionary always wins over this list, so any module where the
 * field means something more specific can simply override the key.
 */
export const commonFieldTooltips = {
  name: "The name HR will see for this record in lists, filters, dropdowns, and reports. Use a name your team already recognizes.",
  short_name: "A short code used where the full name does not fit, such as rosters, tables, and exported reports.",
  code: "A unique code used to identify this record in imports, exports, and integrations. Keep it stable once employees are using it.",
  description: "An internal note for HR explaining when and why this record should be used. Employees do not see it.",
  is_active: "Only active records can be selected in new requests and forms. Turning this off hides it from future use without deleting existing data.",
  is_default: "The value pre-selected for HR when a new record is created. Only one record should be marked as default.",
  remarks: "A short note kept with this record for HR reference and audit history.",
  last_remarks: "The remarks entered by the last person who acted on this request. Visible in the approval history.",
  reason: "Explain why this is being requested. Approvers read this before approving or rejecting, so be specific.",
  attachment: "Supporting document kept with this record as proof. Approvers and HR can open it from the request.",
  file_attachment: "Supporting document kept with this record as proof. Approvers and HR can open it from the request.",
  email: "Official email address used for system notifications and login-related messages.",
  address: "Postal address kept on record. Used in letters, documents, and address-based reports.",
  city: "City kept on record. Used in filters and location-based reporting.",
  country: "Country kept on record. Used in filters, documents, and location-based reporting.",
  title: "A clear title HR and approvers will see in lists and notifications.",
  message: "The text delivered to the recipient exactly as written here.",
  expiry_date: "The date after which this record stops being valid. The system stops applying it from this date onward.",
};

export default commonFieldTooltips;
